import React, { FC } from 'react'
import {
    ActiveState,
    StyledLabel,
    TopicFilterContainer,
    TopicLink,
    TopicLinkList,
    TopicLinkListItem,
    TopicLinkWrapper,
} from './TopicFilter.styled'
import { useHistory, useLocation } from 'react-router'
import { useQueryParams } from '../../../../../web-common/src/hooks/useQueryParams'
import { articleTopics, TOPIC_FILTER_PARAM } from './util'
import { SearchEventProps, getEventName } from '../search-events-util'
import { DataLayerEventName } from '@news-mono/web-common'

export const TopicFilter: FC<SearchEventProps> = ({ onEvent }) => {
    const location = useLocation()
    const history = useHistory()
    const { queryParams, pathname } = useQueryParams()

    const onTopicLinkClicked = (topic: string) => {
        topic === 'All'
            ? queryParams.delete(TOPIC_FILTER_PARAM)
            : queryParams.set(TOPIC_FILTER_PARAM, topic.toLowerCase())

        history.push({
            pathname: pathname,
            search: queryParams.toString(),
        })

        const eventName = getEventName(TOPIC_FILTER_PARAM)

        if (eventName) {
            onEvent({
                type: DataLayerEventName.searchFilter,
                originator: 'TopicFilter',
                payload: {
                    name: eventName,
                    value: topic,
                },
            })
        }
    }

    const getSelectedState = (topic: string): ActiveState => {
        if (topic === 'All') {
            return queryParams.get(TOPIC_FILTER_PARAM) ? 'default' : 'active'
        } else {
            return location.search.includes(`topics=${topic.toLowerCase()}`)
                ? 'active'
                : 'default'
        }
    }

    return (
        <TopicFilterContainer>
            <StyledLabel>Topic</StyledLabel>
            <TopicLinkWrapper>
                <TopicLinkList>
                    {articleTopics.map((topic, i) => (
                        <TopicLinkListItem key={i}>
                            <TopicLink
                                state={getSelectedState(topic)}
                                onClick={() => onTopicLinkClicked(topic)}
                            >
                                {topic}
                            </TopicLink>
                        </TopicLinkListItem>
                    ))}
                </TopicLinkList>
            </TopicLinkWrapper>
        </TopicFilterContainer>
    )
}
